// S2-FE2: GateIndicator
import './GateIndicator.css';

export interface GateIndicatorProps {
  gateId: string;
  name: string;
  score: number;
  threshold: number;
  pass: boolean;
  blocking: boolean;
}

export function GateIndicator({ gateId, name, score, threshold, pass, blocking }: GateIndicatorProps) {
  // Determine visual state: pass, blocking fail, or non-blocking fail
  const state = pass ? 'pass' : blocking ? 'fail-blocking' : 'fail-warn';

  // Format score: show as-is if it looks like cost (e.g. 9.3), otherwise 2 decimals
  const formattedScore = Number.isInteger(score) ? String(score) : score.toFixed(2);

  return (
    <span
      className={`airgent-gate airgent-gate-${state}`}
      title={`Threshold: ${threshold}`}
    >
      {gateId} {name} {formattedScore}
    </span>
  );
}
